export default __webpack_public_path__ + "static/media/Frame_186.f96666b8.jpg";